import ObjectAnalysisType from "./ObjectAnalysisType";
import TableStatisticsType from "./TableStatisticsType";
import IndexStatisticsType from "./IndexStatisticsType";
import InstanceTarget from "../instance/InstanceTarget";
import ObjectDetailsType from "./ObjectDetailsType";

export interface TabType {
    id: string;
    label: string;
    value: "definition" | "statistics" | "insights";
}

export interface ObjectDetailsPanelProps {
    object: ObjectDetailsType | null;
    open: boolean;
    onClose: () => void;
}

export interface ObjectWidgetsProps {
    selectedObject: ObjectDetailsType | null;
    objectAnalysis: ObjectAnalysisType[];
}

export interface ObjectTabsProps {
    tabs: TabType[];
    activeTab: string;
    onTabChange: (value: TabType["value"]) => void;
}

export interface ObjectPanelTableProps {
    loading: boolean;
    optionsList: (TableStatisticsType | IndexStatisticsType)[];
    instance: InstanceTarget;
    setSelectedObject: Function;
    selectedItem: ObjectDetailsType | null;
}

export const TABS: TabType[] = [
    {
        id: "definition-tab",
        label: "Definition",
        value: "definition"
    },
    {
        id: "insights-tab",
        label: "Insights",
        value: "insights"
    }
]; 